import { takeLatest, call, put, select } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/legacy-components';

import { supplierMaterialsService } from 'services/materialService';

import { receiveSupplierMaterialFromGetOrCreate } from 'store/materials/actions';
import { getGroupId } from 'store/session/selectors';

import { getErrorMessage } from 'utils/stringUtils';

import { types, materialModal } from './actions';
import { getSupplierMaterial } from './reducer';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.MATERIAL_MODAL_SAVE_REQUEST, watchMaterialModalSave);
}

function* watchMaterialModalSave(action) {
  const { materialId, data } = action.payload;
  const localSupplierMaterial = yield select(getSupplierMaterial);
  const groupId = yield select(getGroupId);
  try {
    let response;
    if (localSupplierMaterial) {
      response = yield call(
        supplierMaterialsService.update,
        localSupplierMaterial.id,
        data,
      );
    } else {
      response = yield call(
        supplierMaterialsService.create,
        groupId,
        materialId,
        data,
      );
    }
    yield put(materialModal.save.success({ supplierMaterial: response }));
    yield put(
      receiveSupplierMaterialFromGetOrCreate({ supplierMaterial: response }),
    );
  } catch (error) {
    yield call(console.error, error);
    yield put(materialModal.save.error());
    yield call(toast, {
      title: localSupplierMaterial
        ? 'Failed to Update Material'
        : 'Failed to Create Material',
      status: 'error',
      description: getErrorMessage(error),
    });
  }
}
